import { createReducer, createActions } from "reduxsauce";

const { Types, Creators } = createActions({
    eraseData: "",
    // Obtener todos los inversionistas calificados
    submitGetQualifiedInvestors: [""],
    getQualifiedInvestorsSuccess: ["qualifiedInvestors"],
    getQualifiedInvestorsError: ["error"],
    // Actualizar estado del inversionista
    submitUpdateInvestorState: ["investorId", "payload"],
    updateInvestorStateSuccess: ["message"],
    updateInvestorStateError: ["error"],
    // Revisar soporte (prueba)
    submitReviewSupport: [""],
    // Acciones existentes
    submitGetInvestorById: ["investor_id"],
    getInvestorByIdSuccess: ["investorData"],
    submitUpdateInfoInvestors: [
        "file",
        "file_name",
        "investor_id",
        "deposit_account",
        "city_id",
        "city_name",
        "observation",
        "user_email",
        "user_ip"
    ],
    updateInfoInvestorsSuccess: ["message"],
    updateInfoInvestorsError: ["error"],
    submitGetAllCitiesInTheWorld: [""],
    getAllCitiesInTheWorldSuccess: ["countryList"],
});

export const AnnotationByFilesTypes = Types;
export default Creators;

export const INITIAL_STATE = {
    isFetching: false,
    investorData: "",
    qualifiedInvestors: [],
    qualifiedDocuments: [], // Lista de documentos disponibles
    message: "",
    error: "",
    countryList: "",
    lastOperationSuccess: false,
    lastOperationType: null,
    lastStateLabel: null,
};
    
const eraseData = (state) => 
    Object.assign({}, state, {
        isFetching: false,
        message: "",
        error: "",
        lastOperationSuccess: false,
        lastOperationType: null,
        lastStateLabel: null,
    });

// Obtener inversionistas calificados
const submitGetQualifiedInvestors = state =>
    Object.assign({}, state, {
        isFetching: true,
        error: "",
        lastOperationSuccess: false,
    });

const getQualifiedInvestorsSuccess = (state, { qualifiedInvestors }) => {
    return Object.assign({}, state, {
        isFetching: false,
        qualifiedInvestors: qualifiedInvestors?.investors || [],
        qualifiedDocuments: qualifiedInvestors?.documents || [],
        error: "",
    });
};

const getQualifiedInvestorsError = (state, { error }) => {
    return Object.assign({}, state, {
        isFetching: false,
        error,
    });
};

// Actualizar estado del inversionista
const submitUpdateInvestorState = state =>
    Object.assign({}, state, {
        isFetching: true,
        error: "",
        message: "",
        lastOperationSuccess: false,
    });

const updateInvestorStateSuccess = (state, { message }) =>
    Object.assign({}, state, {
        isFetching: false,
        message,
        lastOperationSuccess: true,
        lastOperationType: "changeState",
    });

const updateInvestorStateError = (state, { error }) =>
    Object.assign({}, state, {
        isFetching: false,
        error,
        lastOperationSuccess: false,
    });

// Funciones existentes
const submitGetInvestorById = state =>
    Object.assign({}, state, {
        // isFetching: true
    });

const getInvestorByIdSuccess = (state, { investorData }) =>
    Object.assign({}, state, {
        isFetching: false,
        investorData
    });

const submitUpdateInfoInvestors = state =>
    Object.assign({}, state, {
        isFetching: true
    });

const updateInfoInvestorsSuccess = (state, { message }) =>
    Object.assign({}, state, {
        isFetching: false,
        message
    });

const updateInfoInvestorsError = (state, { error }) =>
    Object.assign({}, state, {
        isFetching: false,
        error
    });

const submitGetAllCitiesInTheWorld = state =>
    Object.assign({}, state, {
        // isFetching: true
    });

const getAllCitiesInTheWorldSuccess = (state, { countryList }) =>
    Object.assign({}, state, {
        isFetching: false,
        countryList
    });

export const reducer = createReducer(INITIAL_STATE, {
    [Types.ERASE_DATA]: eraseData,
    [Types.SUBMIT_GET_QUALIFIED_INVESTORS]: submitGetQualifiedInvestors,
    [Types.GET_QUALIFIED_INVESTORS_SUCCESS]: getQualifiedInvestorsSuccess,
    [Types.GET_QUALIFIED_INVESTORS_ERROR]: getQualifiedInvestorsError,
    [Types.SUBMIT_UPDATE_INVESTOR_STATE]: submitUpdateInvestorState,
    [Types.UPDATE_INVESTOR_STATE_SUCCESS]: updateInvestorStateSuccess,
    [Types.UPDATE_INVESTOR_STATE_ERROR]: updateInvestorStateError,
    [Types.SUBMIT_GET_INVESTOR_BY_ID]: submitGetInvestorById,
    [Types.GET_INVESTOR_BY_ID_SUCCESS]: getInvestorByIdSuccess,
    [Types.SUBMIT_UPDATE_INFO_INVESTORS]: submitUpdateInfoInvestors,
    [Types.UPDATE_INFO_INVESTORS_SUCCESS]: updateInfoInvestorsSuccess,
    [Types.UPDATE_INFO_INVESTORS_ERROR]: updateInfoInvestorsError,
    [Types.SUBMIT_GET_ALL_CITIES_IN_THE_WORLD]: submitGetAllCitiesInTheWorld,
    [Types.GET_ALL_CITIES_IN_THE_WORLD_SUCCESS]: getAllCitiesInTheWorldSuccess,
});